import type { ReqSla } from 'rest/models';

export const UPDATE_REQ_SLAS_MODEL = 'state.persisted.reqSlas.UPDATE_REQ_SLAS_MODEL';

export interface UpdateReqSlasModelAction {
	type: typeof UPDATE_REQ_SLAS_MODEL;
	payload: {
		requestKey: string;
		reqSlas: ReqSla[];
	};
}

export const updateReqSlasModelAction = (
	requestKey: string,
	reqSlas: ReqSla[],
): UpdateReqSlasModelAction => ({
	type: UPDATE_REQ_SLAS_MODEL,
	payload: {
		requestKey,
		reqSlas,
	},
});
